import { ModalConfirmacao } from "@/shared/components/ModalConfirmacao";

interface ModalSairSemSalvarProps {
  aberto: boolean;
  onSair: () => void;
  onContinuar: () => void;
}

/** Aviso padrão do sistema quando a pessoa tenta sair de um Criar/Editar com dados não salvos. */
export function ModalSairSemSalvar({ aberto, onSair, onContinuar }: ModalSairSemSalvarProps) {
  return (
    <ModalConfirmacao
      aberto={aberto}
      titulo="Sair sem salvar?"
      mensagem="Você preencheu informações neste formulário que ainda não foram salvas. Se sair agora, elas serão perdidas."
      textoBotaoConfirmar="Sair sem salvar"
      textoBotaoCancelar="Continuar editando"
      onConfirmar={onSair}
      onCancelar={onContinuar}
    />
  );
}
